import { StyleThemingProps } from '~/utils/styleHelpers'

export const enum CircleBadgeVariant {
  Blue = 'blue',
  Green = 'green',
  Red = 'red',
  Gray = 'gray',
}

export const CircleBadgeStyle = {
  baseStyle: {
    boxSize: '1rem',
    borderRadius: 'full',
    flexShrink: 0,
  },
  variants: {
    [CircleBadgeVariant.Blue]: {
      bg: 'brand.solid',
    },
    [CircleBadgeVariant.Green]: {
      bg: 'green.emphasized',
    },
    [CircleBadgeVariant.Red]: {
      bg: 'red.emphasized',
    },
    [CircleBadgeVariant.Gray]: {
      bg: 'fg.muted',
    },
  },
}

export const useCircleBadgeStyle = (props: StyleThemingProps) => {
  // CircleBadgeStyle is a single-part component, so we just merge and return the styles directly
  const { variants, baseStyle = {} } = CircleBadgeStyle
  const { variant } = props
  const variantKey = variant as CircleBadgeVariant | undefined

  return {
    ...baseStyle,
    ...(variantKey && variantKey in variants ? variants[variantKey] : {}),
  }
}
